// This exists to use reqwest for http requests by default
module.exports = require('../reqwest');



/*****************
 ** WEBPACK FOOTER
 ** ./lib/index.js
 ** module id = 0
 ** module chunks = 0
 **/